export const HOME_PAGE_CATEGORY = '7417';
